import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import { PhoneNumberView } from './phone-number-view';
// tslint:disable-next-line: max-line-length
import { createLinkButtonLegacyDriver } from '../../primitives/deprecated-buttons/deprecated-link-button/link-button.legacy-driver';
// tslint:disable-next-line: max-line-length
import { createDeprecatedPositiveButtonDriver } from '../../primitives/deprecated-buttons/deprecated-button/button.driver';
import { createSelectLegacyDriver } from '../../primitives/selectors/deprecated-single-select/select.legacy-driver';
import { findInPopover } from '../../common/find-in-popover';
export var createPhoneNumberViewDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.phone-number-view', PhoneNumberView.name);
    var openPopover = function () {
        baseDriver.find('.phone-number').click();
        var elem = findInPopover('.call-actions-body').elem;
        return { elem: elem };
    };
    return {
        getPhoneNumber: function () { return baseDriver.find('.phone-number').getText(); },
        getLinesList: function () {
            var elem = openPopover().elem;
            if (elem) {
                return createSelectLegacyDriver(elem).getSelectionTitles();
            }
            return [];
        },
        selectLine: function (index) {
            if (index === void 0) { index = 0; }
            var elem = openPopover().elem;
            if (elem) {
                createSelectLegacyDriver(elem).selectAtIndex(index);
            }
        },
        clickPhoneNumber: function () { return createLinkButtonLegacyDriver(baseDriver.elem).click(); },
        clickCallButton: function () {
            var elem = openPopover().elem;
            if (elem) {
                createDeprecatedPositiveButtonDriver(elem).click();
            }
        }
    };
};
export var createPhoneNumberView = function (props) {
    var elem = renderAndMountComponent(React.createElement(PhoneNumberView, __assign({}, props)));
    return createPhoneNumberViewDriver(elem);
};
//# sourceMappingURL=phone-number-view.driver.js.map